import { ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';

/**
 * 用户信息对象
 */
interface UserInfo {
  fetch: number; // 抽奖次数
  gold: number; // 当前分值
  score_exp: number; // 抽奖需要的分值
  userid: number; // 用户ID
  score: number; // 分值
}

/**
 * 记录对象
 */
interface Record {
  info: UserInfo; // 用户信息对象
  cashstart: number; // 开始提现的金额
}

/**
 * Jackpot 响应对象
 */
interface JackpotResponse<T> {
  ret: number; // 返回码，0 表示成功
  record: T; // 记录对象
  pool?: number;
}

/**
 * 排名记录项
 */
interface RankRecord {
  rdate: string; // 排名日期
  award: number; // 奖励金额
  userid: number; // 用户ID
  username: string; // 用户名
}

interface AwardRecord {
  tjdate: string; // 统计日期
  recordid: string; // 记录ID
  after: number; // 之后的值
  before: number; // 之前的值
  rdate: string; // 排名日期和时间
  award: number; // 奖励金额
  userid: number; // 用户ID
  taskid: number; // 任务ID
}

/**
 * 中奖记录查询
 * @returns {Promise<AwardRecord[]>}
 */
export const getJackpotRecordList = (): Promise<JackpotResponse<AwardRecord[]>> => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/jp_record',
    method: 'post',
    data: { userid }
  });
};

/**
 * @returns {Promise<RankResponse>} 排名信息响应对象
 */
export const getJackpotRankList = (): Promise<JackpotResponse<RankRecord[]>> => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/get_jp_rank',
    method: 'post',
    data: { userid }
  });
};

/**
 * 获取当前用户的 Jackpot 数据
 * @returns {Promise<JackpotResponse>} 响应对象
 */
export const getJackpotInfo = (): Promise<JackpotResponse<Record>> => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/get_userinfo',
    method: 'post',
    data: {
      userid
    }
  });
};

/**
 * 查询当前jackpot奖池（首次进入大厅要调用此接口来查询)
 * @returns
 */
export const getJackpotScore = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/query_jpscore',
    method: 'post',
    data: { userid }
  });
};

/**
 * 抽奖
 * @returns
 */
export const getJackpotAward = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/gain_jpaward',
    method: 'post',
    data: { userid }
  });
};

/**
 * 推送
 * @returns
 */
export const startRegister = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/register_query_jpscore',
    method: 'post',
    data: { userid }
  });
};

/**
 * 推送注销
 * @returns
 */
export const startUnRegister = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/unregister_query_jpscore',
    method: 'post',
    data: { userid }
  });
};

/**
 * 推送心跳包
 * @returns
 */
export const heartBeat = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/jp/jp_heartbeat',
    method: 'post',
    data: { userid }
  });
};
